// Display-only unit conversions. Underlying recipe values are always stored in metric (g, ml, °C).
export function fmtWeight(g, prefs) {
  if (g == null || g === "") return "";
  const u = prefs?.weight_unit || "g";
  if (u === "oz") return `${(Number(g) / 28.3495).toFixed(2)} oz`;
  return `${Number(g)} g`;
}

export function fmtVolume(ml, prefs) {
  if (ml == null || ml === "") return "";
  const u = prefs?.volume_unit || "ml";
  if (u === "floz") return `${(Number(ml) / 29.5735).toFixed(1)} fl oz`;
  return `${Number(ml)} ml`;
}

export function fmtTemp(c, prefs) {
  if (c == null || c === "") return "";
  const u = prefs?.temp_unit || "C";
  if (u === "F") return `${Math.round((Number(c) * 9) / 5 + 32)}°F`;
  return `${Number(c)}°C`;
}

// Editable-field conversions: inputs shown in the customer's unit, stored as metric.
const OZ = 28.3495;
const FLOZ = 29.5735;
const r2 = (n) => Math.round(n * 100) / 100;
const r1 = (n) => Math.round(n * 10) / 10;

export const weightUnitLabel = (p) => (p?.weight_unit === "oz" ? "oz" : "g");
export const volumeUnitLabel = (p) => (p?.volume_unit === "floz" ? "fl oz" : "ml");
export const tempUnitLabel = (p) => (p?.temp_unit === "F" ? "°F" : "°C");

export const toDispWeight = (g, p) => (p?.weight_unit === "oz" ? r2(Number(g) / OZ) : Number(g));
export const fromDispWeight = (v, p) => (p?.weight_unit === "oz" ? Number(v) * OZ : Number(v));
export const toDispVolume = (ml, p) => (p?.volume_unit === "floz" ? r1(Number(ml) / FLOZ) : Number(ml));
export const fromDispVolume = (v, p) => (p?.volume_unit === "floz" ? Number(v) * FLOZ : Number(v));
export const toDispTempN = (c, p) => (p?.temp_unit === "F" ? Math.round((Number(c) * 9) / 5 + 32) : Number(c));
export const fromDispTempN = (v, p) => (p?.temp_unit === "F" ? ((Number(v) - 32) * 5) / 9 : Number(v));
